import script from "./DemandView.vue?vue&type=script&setup=true&lang=ts"
export * from "./DemandView.vue?vue&type=script&setup=true&lang=ts"

import "./DemandView.vue?vue&type=style&index=0&id=6bb141db&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bb141db"]])

export default __exports__